<template>
  <div class="content">
    <div class="container-fluid p-0 row d-flex justify-content-center">
        <router-link to="/newpuasset" class="col-3 text-decoration-none">
            <div class="newPuCard card mb-3 py-3" style="max-width: 24rem;">
                <div class="card-body text-center">
                    <i class="nc-icon nc-bank mb-3" style="font-size: 40px;"></i>
                    <h4 class="m-0">Hlášení majetku</h4>
                </div>
            </div>
        </router-link>

        <router-link to="/newpuasset" class="col-3 text-decoration-none">
          <div class="newPuCard card mb-3 py-3" style="max-width: 24rem;">
              <div class="card-body text-center">
                  <i class="nc-icon nc-bus-front-12 mb-3" style="font-size: 40px;"></i>
                  <h4 class="m-0">Vozidlo</h4>
              </div>
          </div>
        </router-link>

        <router-link to="/newpuasset" class="col-3 text-decoration-none">
          <div class="newPuCard card mb-3 py-3" style="max-width: 24rem;">
              <div class="card-body text-center">
                  <i class="nc-icon nc-bag mb-3" style="font-size: 40px;"></i>
                  <h4 class="m-0">Odpovědnost</h4>
              </div>
          </div>
        </router-link>
    </div>
  </div>
</template>

<script>
  export default {
    components: {
    },
    methods: {
    },
    data () {
      return {
      }
    }
  }
</script>

<style>
.newPuCard {
    border-color: #2992c8 !important;
    color: black;
}

h4 {
  font-weight: 300 !important;
}

.newPuCard:hover {
    background-color: #2992c8;
    color: white !important;
    cursor: pointer;
}
</style>